<div class="row ms-2 ps-0 pe-0 ms-md-0 ms-md-0 ps-md-0">
  <div class="col-11 col-lg-5 col-md-8 col-sm-10 ps-auto ps-md-0">
    <h2 class="mb-3 mt-0">{{localize(langSection.AddRequestPage, langText.Header)}}</h2>
    <p class="m-1">{{localize(langSection.AddRequestPage, langText.Description)}}</p>
    <p class="py-0"><span>* {{localize(langSection.Term, langText.RequiredFieldNotice)}}</span></p>

    <div id="AddRequestInputs" class="col-12 col-sm-10 col-md-7 ps-0 pe-0">
      <div class="mb-3" [class.error]="showError">
        <label class="fw-bold form-label">{{localize(langSection.AddRequestPage, langText.CustomerLocation)}} *</label>
        <location-address-search-input [value]="formattedValue" (onSelect)="onLocationSelect($event)"
          (onChange)="onLocationValueChange($event)" [excludeViewOnly]="true"></location-address-search-input>
        @if (showError) {
<span class="error-icon"></span>
}
        @if (showError) {
<span class="text-danger">{{localize(langSection.AddRequestPage,
          langText.ValidLocation)}}</span>
}
      </div>
      <div>
        <label class="fw-bold form-label">{{localize(langSection.AddRequestPage, langText.RequestType)}} *</label>
        <ups-select [list]="requestTypes" [value]="type"
          (change)="onRequestTypeSelected($event.target.value)"></ups-select>
      </div>
    </div>
  </div>
</div>
<div class="row pt-3 ms-2 ps-0 pe-0 ms-md-0 ms-md-0 ps-md-0">
  <div class="col-11 col-lg-5 col-md-8 col-sm-10 ps-auto ps-md-0">
    <button class="py-2 px-5 border-0 text-white bg-green me-4 round-button"
      (click)="onNext()">{{localize(langSection.Term, langText.Next)}}</button>
    <a routerLink="/">{{localize(langSection.Term, langText.Cancel)}}</a>
  </div>
</div>